import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => `0 0 ${theme.spacing(6)} 0`};
`;
